<template>
  <div class="">
    <p>data Attribute</p>



    <m-a href="https://github.com/michalsnik/aos">
      aos
    </m-a>


    <div class="col-12">
      <div class="row my-2" v-for="(item,index) in component.dataAttribute">
        <div class="col p-0">
          <input type="text" readonly :value="index" class="form-control">
        </div>
        <div class="col p-0">
          <input type="text" v-model="component.dataAttribute[index]" class="form-control">
        </div>

        <i class="bi bi-trash h4" @click="removeAttribute(index)"></i>

      </div>
    </div>


    <div class="btn btn-primary" data-toggle="modal" data-target="#createDataAttribute">ساخت ایتم جدید</div>


    <div class="modal fade" id="createDataAttribute" tabindex="-1" aria-labelledby="exampleModalLabel"
         aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="createAttribute" class="text-left" dir="ltr">
              <div class="form-group">
                <label for="dateAttributeKey">date Attribute Key</label>
                <input required type="text" v-model="form.attributeKey" class="form-control" id="dateAttributeKey">
              </div>
              <div class="form-group">
                <label for="dateAttributeValue">date Attribute value</label>
                <input required type="text" v-model="form.attributeValue" class="form-control" id="dateAttributeValue">
              </div>

              <div class="text-center">
                <button type="submit" class="btn btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "ComponentDataAttributeManager",
  props: {
    component: {}
  },
  data() {
    return {
      form: {
        attributeKey: '',
        attributeValue: '',
      }
    }
  },
  methods: {
    initDataAttribute() {
      if (Object.keys(this.component).indexOf('dataAttribute') == -1) {
        this.component['dataAttribute'] = {}
      }
    },
    removeAttribute(index) {
      if (confirm('آیا از حذف اطمینان دارید؟')) {
        delete this.component.dataAttribute[index]
      }
    },
    createAttribute() {
      let key = this.form.attributeKey
      let value = this.form.attributeValue
      this.component.dataAttribute[key] = value
    }
  },
  mounted() {
    this.initDataAttribute()
  }
}
</script>

<style scoped>

</style>